import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const uploadElementItems = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('event_id', localStorage?.getItem('event_id'));
  formData.append('user_id', localStorage?.getItem('user_id'));

  return axios.post(`${API_URL}/element_items/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const getElementItemsByEvent = async (eventId, location, userId, zone) => {
  const params = {};
  if (location) params.location = location;
  if (userId) params.user_id = userId;
  if (zone) params.zone = zone;
  return axios.get(`${API_URL}/element_items/byevent/${eventId}`, {
    params,
  });
};

const getElementLocations = async (eventId) => {
  return axios.get(`${API_URL}/element_items/locations/${eventId}`);
};

const getElementZones = async (eventId, location) => {
  return axios.get(`${API_URL}/element_items/zones/${eventId}`, {
    params: location ? { location } : {},
  });
};

const updateElementItem = async (id, data) => {
  return axios.put(`${API_URL}/element_items/${id}`, data);
};

const createElementItem = async (data) => {
  return axios.post(`${API_URL}/element_items/`, data);
};

const deleteElementItem = async (id) => {
  return axios.delete(`${API_URL}/element_items/${id}`);
};

const clearElementItems = async (eventId) => {
  return axios.delete(`${API_URL}/element_items/byevent/${eventId}`);
};

const textValue = (value) =>
  value === undefined || value === null ? '' : value;

const normalizeStatus = (value) => {
  const text = String(value || '').trim().toLowerCase();
  if (text === 'verified') return 'verified';
  if (text === 'discrepancy' || text === 'descripency' || text === 'discrepency') {
    return 'discrepancy';
  }
  if (text === 'exceeded') return 'exceeded';
  return '';
};

const toRow = (item) => ({
  id: item.id,
  sr: textValue(item.sr_no),
  particulars: textValue(item.particulars),
  dimensions: textValue(item.dimensions),
  quantity: textValue(item.quantity),
  unit: textValue(item.unit),
  size: textValue(item.size),
  status: normalizeStatus(item.status || item.verification_status),
  statusUpdatedBy: textValue(item.status_updated_by),
  remarks: textValue(item.remarks),
  sortOrder: item.sort_order,
  updatedAt: textValue(item.updated_at || item.updatedAt || item.modified_at),
  createdAt: textValue(item.created_at || item.createdAt),
});

const flattenMonitorItems = (payload) => {
  const locations = locationsFromPayload(payload);
  const items = [];
  locations.forEach((location) => {
    location.sections.forEach((section) => {
      section.rows.forEach((row) => {
        items.push({
          ...row,
          location: location.location,
          sectionCode: section.code,
          sectionTitle: section.title,
        });
      });
    });
  });
  return { locations, items };
};

const groupElementItems = (payload) => {
  const source = Array.isArray(payload?.sections)
    ? payload.sections
    : (payload?.locations || []).flatMap((location) => location.sections || []);
  const sections = toSections(source);

  return {
    total: payload?.total ?? sections.reduce((sum, section) => sum + section.rows.length, 0),
    sections,
  };
};

const toSections = (sections) =>
  (sections || []).map((section, index) => ({
    key: `${section.section_code || 'section'}-${index}-${section.section_name || ''}`,
    code: textValue(section.section_code),
    title: textValue(section.section_name) || 'Section',
    rows: (section.items || []).map((item, itemIndex) => ({
      ...toRow(item),
      sr: String(itemIndex + 1),
    })),
  }));

const locationsFromPayload = (payload) => {
  const nested =
    Array.isArray(payload?.locations) &&
    payload.locations.some((item) => Array.isArray(item?.sections));
  const groups = nested
    ? payload.locations
    : [
        {
          location: payload?.location || 'Location',
          sections: payload?.sections || [],
        },
      ];

  return groups
    .map((location) => ({
      location: textValue(location.location) || 'Location',
      sections: toSections(location.sections),
    }))
    .filter((location) => location.sections.length > 0);
};

export default {
  uploadElementItems,
  getElementItemsByEvent,
  getElementLocations,
  getElementZones,
  updateElementItem,
  createElementItem,
  deleteElementItem,
  clearElementItems,
  groupElementItems,
  locationsFromPayload,
  flattenMonitorItems,
};
